module.exports = __webpack_public_path__ + "img/terminal.47905ede.svg";